import { useReactNodeView } from '@tiptap/react';
import React from 'react';

export interface NodeViewWrapperProps {
  [key: string]: any;
  as?: React.ElementType;
}

/*
 * This is a fork of the original NodeViewWrapper component from
 * https://github.com/ueberdosis/tiptap/blob/v2.8.0/packages/react/src/NodeViewWrapper.tsx.
 *
 * The primary modification addresses a drag-and-drop issue in React 16.
 * This implementation manually attaches the `onDragStart` handler using the
 * `ref` and the DOM's `addEventListener` API.
 *
 * Note: This workaround is unnecessary in React 18 as ref forwarding and
 * event handling work correctly.
 */
export const NodeViewWrapper: React.FC<NodeViewWrapperProps> = props => {
  const ref = React.useRef<HTMLElement | null>(null);
  const { onDragStart } = useReactNodeView();
  const Tag = props.as || 'div';

  React.useEffect(() => {
    if (!ref?.current || !onDragStart) {
      return;
    }

    ref?.current.addEventListener('dragstart', onDragStart);

    return () => {
      ref?.current?.removeEventListener('dragstart', onDragStart);
    };
  }, [ref?.current]);

  return (
    <Tag
      {...props}
      ref={ref}
      data-node-view-wrapper=""
      style={{
        whiteSpace: 'normal',
        ...props.style,
      }}
    />
  );
};
